/**
 * In Audit API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const AuditStatus = {
    Progress: 'progress',
    Finish: 'finish',
    Archived: 'archived'
} as const;
export type AuditStatus = typeof AuditStatus[keyof typeof AuditStatus];

